<div class="field-wrapper" fxLayout="row" fxLayoutAlign="space-around flex-start">
    <div class="label" fxFlex="30">
        {{label}}
        <small *ngIf="labelCaption"><br>{{labelCaption}}</small>
    </div>

    <div class="value" fxFlex="70" [class.centered]="centeredValue">
        <ng-container *ngIf="isValid; else noValue">
            <ng-content></ng-content>
        </ng-container>
        <ng-template #noValue>
            <small class="invalid">{{defaultValue}}</small>
        </ng-template>
    </div>
</div>
